// These should be overridden by the implementation
let user = {
  getAccessToken: () => null,
};

export default user;
